import { api } from '../api.js';

export interface Environment {
    id: string;
    name: string;
    description: string | null;
    themeColor: string;
    allowedIps: string[];
    createdAt: string;
    updatedAt: string;
}

class EnvironmentStore {
    list = $state<Environment[]>([]);
    currentId = $state<string | null>(localStorage.getItem('keyvault.currentEnv'));
    loading = $state(false);

    get current(): Environment | null {
        return this.list.find((e) => e.id === this.currentId) ?? null;
    }

    async load() {
        this.loading = true;
        try {
            this.list = await api<Environment[]>('/api/environments');
            if (!this.currentId && this.list.length > 0) {
                this.setCurrent(this.list[0].id);
            } else if (this.currentId && !this.list.find((e) => e.id === this.currentId)) {
                this.setCurrent(this.list[0]?.id ?? null);
            }
        } finally {
            this.loading = false;
        }
    }

    setCurrent(id: string | null) {
        this.currentId = id;
        if (id) localStorage.setItem('keyvault.currentEnv', id);
        else localStorage.removeItem('keyvault.currentEnv');
    }
}

export const envs = new EnvironmentStore();